import { c as _c } from "react/compiler-runtime";
import React from "react";
import { Icon, IconProps } from "@/components/ui/Icon";
import type { IconName } from "@/types/icons";
export interface TagProps {
  icon: IconName;
  iconSize?: IconProps["size"];
  label: string;
  iconClassName?: string;
}
export const Tag: React.FC<TagProps> = t0 => {
  const $ = _c(9);
  const {
    icon,
    iconSize: t1,
    label,
    iconClassName: t2
  } = t0;
  const iconSize = t1 === undefined ? 16 : t1;
  const iconClassName = t2 === undefined ? "" : t2;
  const t3 = `${iconClassName}`;
  let t4;
  if ($[0] !== icon || $[1] !== iconSize || $[2] !== t3) {
    t4 = <Icon name={icon} size={iconSize} className={t3} />;
    $[0] = icon;
    $[1] = iconSize;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== label) {
    t5 = <span className="text-md">{label}</span>;
    $[4] = label;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4 || $[7] !== t5) {
    t6 = <div className="flex flex-row justify-center items-center gap-2">{t4}{t5}</div>;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
};